import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { UtilsService } from '../services/utils.service';

@Injectable({
    providedIn: 'root'
})
export class OnlyDesktopGuard  {

    private readonly _utilsService = inject(UtilsService);
    private readonly _router = inject(Router);

    canActivate(
        next: ActivatedRouteSnapshot,
        state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
        return this.verificaAcesso();
    }

    private verificaAcesso = (): boolean => {
        
        if (this._utilsService.isMobileDevice() || this._utilsService.checkIsMobile()) {
            this._router.navigateByUrl('/cotacoes');
            return false;
        }

        return true;

    }
}
